import MotionInView from "./MotionView";
import {
    Box,
    Heading,
    Text,
    Image,
    SimpleGrid,
    Stack,
    Icon,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
} from "@chakra-ui/react";
import { MdCalendarMonth, MdLocationOn, MdPhone } from "react-icons/md";

const Bal = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    return (
        <Box py={{ base: 12, md: 16 }} px={{ base: 5, md: 8 }} bg="gray.50">
            <MotionInView y={12}>
                <Stack align="center" textAlign="center" spacing={4} mb={{ base: 10, md: 12 }}>
                    <Heading fontSize={{ base: "3xl", md: "5xl" }} fontWeight="900">
                        Tavaszi Est a Bástyáért
                    </Heading>
                    <Box w="90px" h="4px" bg="yellow.400" rounded="full" />
                    <Text maxW="700px" color="gray.600" fontSize={{ base: "md", md: "lg" }}>
                        Szeretettel hívjuk Önt és családját a Bástya jótékonysági alkalmára.
                    </Text>
                </Stack>
            </MotionInView>

            <SimpleGrid
                columns={{ base: 1, lg: 2 }}
                spacing={{ base: 10, md: 12 }}
                maxW="1200px"
                mx="auto"
                alignItems="center"
            >
                <MotionInView x={-18} y={10}>
                    <Box
                        bg="white"
                        rounded="2xl"
                        p={{ base: 6, md: 8 }}
                        boxShadow="sm"
                        borderWidth="1px"
                        borderColor="gray.200"
                    >
                        <Stack spacing={6}>
                            <Box>
                                <Text
                                    color="yellow.500"
                                    fontWeight="800"
                                    textTransform="uppercase"
                                    letterSpacing="0.08em"
                                    mb={2}
                                >
                                    Jótékonysági rendezvény
                                </Text>
                                <Heading fontSize={{ base: "2xl", md: "4xl" }} fontWeight="900">
                                    Tavaszi Est
                                </Heading>
                            </Box>

                            <Text color="gray.700" lineHeight="1.8">
                                Rendezvényünk célja, hogy egy tartalmas és emlékezetes este keretében
                                közösen támogassuk intézményünket. Szeretettel várjuk mindazokat,
                                akik egy jó hangulatú program részesei szeretnének lenni.
                            </Text>

                            <Stack spacing={4}>
                                <Box display="flex" alignItems="flex-start" gap={3}>
                                    <Icon as={MdCalendarMonth} boxSize={6} color="yellow.500" mt="2px" />
                                    <Box>
                                        <Text fontWeight="700">Időpont</Text>
                                        <Text color="gray.600">Május 2. – 19:00</Text>
                                    </Box>
                                </Box>

                                <Box display="flex" alignItems="flex-start" gap={3}>
                                    <Icon as={MdLocationOn} boxSize={6} color="yellow.500" mt="2px" />
                                    <Box>
                                        <Text fontWeight="700">Helyszín</Text>
                                        <Text color="gray.600">Tiszalöki Művelődési Ház</Text>
                                    </Box>
                                </Box>

                                <Box display="flex" alignItems="flex-start" gap={3}>
                                    <Icon as={MdPhone} boxSize={6} color="yellow.500" mt="2px" />
                                    <Box>
                                        <Text fontWeight="700">Elővétel / Információ</Text>
                                        <Text color="gray.600">Bástya Idősotthon – 06/30 144 9427</Text>
                                    </Box>
                                </Box>
                            </Stack>

                            <Box
                                bg="yellow.50"
                                borderWidth="1px"
                                borderColor="yellow.200"
                                rounded="xl"
                                p={4}
                            >
                                <Text fontWeight="900" fontSize={{ base: "lg", md: "xl" }}>
                                    Belépő: 12.000 Ft
                                </Text>
                                <Text mt={1} color="gray.700">
                                    Tombola felajánlásokat is szívesen fogadunk.
                                </Text>
                            </Box>
                        </Stack>
                    </Box>
                </MotionInView>

                <MotionInView x={18} y={10}>
                    <Box
                        bg="white"
                        rounded="2xl"
                        p={{ base: 3, md: 4 }}
                        boxShadow="sm"
                        borderWidth="1px"
                        borderColor="gray.200"
                    >
                        <Image
                            src="/images/tavasziest.png"
                            alt="Tavaszi Est plakát"
                            w="100%"
                            rounded="xl"
                            objectFit="contain"
                            cursor="zoom-in"
                            onClick={onOpen}
                            transition="transform 0.2s ease"
                            _hover={{ transform: "scale(1.01)" }}
                        />
                    </Box>
                </MotionInView>
            </SimpleGrid>

            <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
                <ModalOverlay bg="blackAlpha.800" />
                <ModalContent bg="transparent" boxShadow="none">
                    <ModalCloseButton color="white" bg="blackAlpha.600" _hover={{ bg: "blackAlpha.700" }} />
                    <ModalBody p={{ base: 2, md: 6 }} display="flex" justifyContent="center">
                        <Image
                            src="/images/tavasziest.png"
                            alt="Tavaszi Est plakát nagyban"
                            maxH="90vh"
                            w="auto"
                            rounded="xl"
                            objectFit="contain"
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Box>
    );
};

export default Bal;